import React, { useEffect, useState, useRef } from "react";
import classes from "./CashMovements.module.css";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import searchicon from "../../../Assets/searchicon.png";
import filter from "../../../Assets/filter.png";
import upload from "../../../Assets/upload.svg"
import down from "../../../Assets/download.svg"
import { Pen, Trash2, Printer } from "lucide-react";
import axios from "axios";
import RotatingLogo from '../../../Assets/rotating-logo.png'
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { Button, Modal, Form, Spinner, Tab, Tabs, Row, Col, Popover, Badge } from 'react-bootstrap';
import Select from "react-select";
import crop from "../../../Assets/repoort.png";
import verified from "../../../Assets/verified.svg";
import Swal from "sweetalert2";
import CurrencyInput from "react-currency-input-field";
import HeaderNav from "../../Accoungting/HeaderNav/HeaderNav";
import { BASE_URL } from "../../../Components/Styles/API/API";
import CashReciept from "../../Accounting/Payments/CashReciept/CashReciept";
import CashMovementsModal from "./CashMovementsModal";
import EyeIcon from "../../../Assets/new-eye.svg"




const CashMovements = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [selectedOption, setSelectedOption] = useState("all");
  const [currentPageFlagged, setCurrentPageFlagged] = useState(1);
  const [totalPagesFlagged, setTotalPagesFlagged] = useState(1);
  const [uploadLoading, setUploadLoading] = useState(false);
  const [receive, setReceive] = useState('');
  const [invoices, setInvoices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [show1, setShow1] = useState(false);
  const [show2, setShow2] = useState(false);
  const handleShow1 = () => setShow1(true);
  const handleShow2 = () => setShow2(true);
   const [selectedDate2, setSelectedDate2] = useState('');
  const handleClose1 = () => setShow1(false);
  const handleClose2 = () => setShow2(false);
  const [selectedRadio, setSelectedRadio] = useState("");
  const [customerName, setCustomerName] = useState("");
  const [paymentDate, setPaymentDate] = useState("");
  const [description, setDescription] = useState("");
  const [amount, setAmount] = useState("");
  const [currencyOptions, setCurrencyOptions] = useState([]);
  const [bankOptions, setBankOptions] = useState([]);
  const [bankOptions2, setBankOptions2] = useState([]);
  const [paymentMode, setPaymentMode] = useState([]);
  const [selectedCurrency, setSelectedCurrency] = useState(null);
  const [selectedBank, setSelectedBank] = useState(null);
  const [selectedBank2, setSelectedBank2] = useState(null);
  const [selectedPaymentMode, setSelectedPaymentMode] = useState(null);
  const [customerOptions, setCustomerOptions] = useState([]);
  const [invoiceOptions, setInvoiceOptions] = useState([]);
  const [addpaymenntLoad, setAddPaymenntLoad] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [addpaymenntLoad2, setAddPaymenntLoad2] = useState(false);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [selectedInvoice, setSelectedInvoice] = useState(null);
  const [entriesPerPage, setEntriesPerPage] = useState(100);
  const [currentPage, setCurrentPage] = useState(1);
  const [bearer, setBearer] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [tableData2, setTableData2] = useState([]);
  const [user, setUser] = useState('');
  const [minDate, setMinDate] = useState("");
    const [maxDate, setMaxDate] = useState("");
    const [selectedDate, setSelectedDate] = useState('');
const [selectedPayment, setSelectedPayment] = useState('');
const [selectedBanks, setSelectedBanks] = useState('');
const [selectedDebitAccount, setSelectedDebitAccount] = useState('');
 const [paymentMethod, setPaymentMethod] = useState([]);
 const [formData, setFormData] = useState([{ sn: 1, accountName: '', accountCode: '', amount: '' }]);
 const [teller, setTeller] = useState('');
    const [incomeLoading, setIncomeLoading] = useState(false);
     const [debit1, setDebit1] = useState([]);
      const [show, setShow] = useState(false);
    const [debit2, setDebit2] = useState([]);
    const [income, setIncome] = useState([]);
    const [ledgTableData2, setLedgTableData2] = useState([]);
    const [incomeAmount, setIncomeAmount] = useState();
    const [totalCredit, setTotalCredit] = useState(0);
    const [selectOptions, setSelectOptions] = useState([]);
    const [currentMonth, setCurrentMonth] = useState('');
     const [subCat, setSubcat] = useState([]);
    const [subCat1, setSubcat1] = useState([]);
    const [banks, setBanks] = useState([]);
    const [currLoading, setCurrLoading] = useState(false);
    const [currency, setCurrency] = useState([]);
  const [benLoading, setBenLoading] = useState(false);
   const [searchTerm,setSearchTerm] = useState("");
    const [foundCashUUID, setFoundCashUUID] = useState("");
     const [cashID, setCashID] = useState('');
       const [foundCashArrays, setFoundCashArrays] = useState([]);
        const [selectedDate12, setSelectedDate12] = useState('');
        const [load, setLoad] = useState(false);
        const handleClose = () => setShow(false);
    const readData = async () => {
      try {
        const value = await localStorage.getItem('userToken');
        const value1 = await localStorage.getItem('tobi');
        const current = await localStorage.getItem('currentMonth');
  
  
        if (value !== null && value.trim() !== '') {
          setBearer(value);
        } else {
          navigate('/login');
          return;
        }
  
        if (value1 !== null) {
          setUser(value1);
        }
        if (current !== null) {
  const date = new Date(current);

  setCurrentMonth(date);

  // 1st and last days of that month
  const startOfDateRange = new Date(date.getFullYear(), date.getMonth(), 1);
  const endOfDateRange = new Date(date.getFullYear(), date.getMonth() + 1, 0);

  // Format date as 'YYYY-MM-DD'
  const formatDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  setMinDate(formatDate(startOfDateRange));
  setMaxDate(formatDate(endOfDateRange));

  console.log(
    'Date Range:',
    formatDate(startOfDateRange),
    'to',
    formatDate(endOfDateRange)
  );
}
  
      } catch (e) {
        alert('Failed to fetch the input from storage');
      }
    };
  
    useEffect(() => {
      readData();
    }, []);


      const headers = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${bearer}`
  };

  
const addRow = () => {
        const newRow = {
            sn: formData.length + 1,
            accountName: '',
            accountCode: '',
            amount: ''
        };
        setFormData([...formData, newRow]);
        // setSelectedPayment('');
    };

    const deleteRow = (index) => {
        const updatedData = formData.filter((_, i) => i !== index);
        setFormData(updatedData);
    };

   const createJournals = async () => {
  const confirmed = await Swal.fire({
    title: 'Are you sure?',
    text: 'You are about to reverse this transaction.',
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#d33',
    confirmButtonText: 'Yes, reverse it!',
    cancelButtonText: 'No, cancel',
  });

  if (!confirmed.isConfirmed) {
    return;
  }
  
  setLoad(true);

  try {
    const response = await axios.post(`${BASE_URL}/cash_movement/reversal`,
      {
       uuid: foundCashUUID
      },
      { headers }
    );
   

    Swal.fire({
      icon: 'success',
      title: 'Successful',
      text: response.data.message,
    });
    navigate(-1);
  } catch (error) {
    let errorMessage = 'An error occurred. Please try again.';
    if (error.response && error.response.data && error.response.data.message) {
      if (typeof error.response.data.message === 'string') {
        errorMessage = error.response.data.message;
      } else if (Array.isArray(error.response.data.message)) {
        errorMessage = error.response.data.message.join('; ');
      } else if (typeof error.response.data.message === 'object') {
      
        console.log(errorMessage);
      }
    }
    Swal.fire({
      icon: 'error',
      title: 'Failed',
      text: JSON.stringify(error.response.data.message),
    });
    //   console.log(error);
  } finally {
    setLoad(false);
  }
};

    const fetchIncome = async () => {
        setLoading(true);
    
        try {
          const response = await axios.get(`${BASE_URL}/account/incomes-receivables-payables`,{headers});
        //     {
             
        //       headers: { 
        //         'Content-Type': 'application/json',
        //         'Authorization': `Bearer ${bearer}`
        //       }
        //     }
        //   );
          const inc = response.data?.data;

          setIncome(inc);
          
         
    
        //   console.log(debitAcc, "Debit Accounts");
        } catch (error) {
          const errorStatus = error.response.data.message;
          console.error(errorStatus);
        } finally {
          setLoading(false);
        }
      };

      useEffect(() => {
        
        fetchIncome();
    }, [bearer]);

      const uploadExcel = async () => {
      setUploadLoading(true);
        try {
          const formData = new FormData();
        formData.append('file', selectedFile[0]);
        formData.append('transaction_date', selectedDate2);
       
        // console.log(selectedFile);
    
        const headers = {
          'Content-Type': 'multipart/form-data',
          'Authorization': `Bearer ${bearer}`,
        };
    
        // const response = await axios.post(`${BASE_URL}/customer/import`,
        const response = await axios.post(`${BASE_URL}/upload-receipt-excel`,
          formData,
          { headers }
        );
    handleClose2();
    fetchData();
        Swal.fire({
          icon: 'success',
          title: 'Success',
          text: response.data.message,
        });
    
        console.log(response.data.message);
      } catch (error) {
        const errorStatus = error.response.data.message;
    
        Swal.fire({
          icon: 'error',
          title: 'Failed',
          text: errorStatus,
        });
    
        console.error(error);
      } finally {
        setUploadLoading(false);
        }
      };

    const fetchSubCat = async () => {
        setLoading(true);
    
        try {
          const response = await axios.get(`${BASE_URL}/account`,{headers});
        //     {
             
        //       headers: { 
        //         'Content-Type': 'application/json',
        //         'Authorization': `Bearer ${bearer}`
        //       }
        //     }
        //   );
          const results = response.data?.data;
          const oopt = results.map((item) => ({
            label: item.gl_name,
            value: item.id,
         
            
          }));
          setSubcat(oopt);
          setSubcat1(results);
    
        //   console.log(results, "Accounts");
        } catch (error) {
          const errorStatus = error.response.data.message;
          console.error(errorStatus);
        } finally {
          setLoading(false);
        }
      };

         const handleFileChange = (event) => {
      const files = event.target.files;
      const fileList = Array.from(files);
      setSelectedFile(fileList);
      
    };

    const fetchDebit1 = async () => {
        setLoading(true);
    
        try {
          const response = await axios.get(`${BASE_URL}/account/bank-accounts`,{headers});
        
          const debt1 = response.data?.data;
          const oopt1 = debt1.map((item) => ({
            label: `${item.gl_code} - ${item.gl_name}`,
            value: item.id,
         
            
          }));
          setDebit1(oopt1);
     
    
      
        } catch (error) {
          const errorStatus = error.response.data.message;
          console.error(errorStatus);
        } finally {
          setLoading(false);
        }
      };
    const fetchDebit2 = async () => {
        setLoading(true);
    
        try {
          const response = await axios.get(`${BASE_URL}/account/cash`,{headers});
        
          const debt2 = response.data?.data;
          const oopt2 = debt2.map((item) => ({
            label: `${item.gl_code} - ${item.gl_name}`,
            value: item.id,
         
            
          }));
          setDebit2(oopt2);
     
    
      
        } catch (error) {
          const errorStatus = error.response.data.message;
          console.error(errorStatus);
        } finally {
          setLoading(false);
        }
      };

    const fetchSubBanks = async () => {
        setLoading(true);
    
        try {
          const response = await axios.get(`${BASE_URL}/get-banks`,{headers});
        //     {
             
        //       headers: { 
        //         'Content-Type': 'application/json',
        //         'Authorization': `Bearer ${bearer}`
        //       }
        //     }
        //   );
          const banked = response.data?.data;
          const ban1 = banked.map((item) => ({
            label: item.bank_name,
            value: item.id,
         
            
          }));
          setBanks(ban1);
        //   console.log(response);
        } catch (error) {
          const errorStatus = error.response.data.message;
          console.error(errorStatus);
        } finally {
          setLoading(false);
        }
      };

      const createIncome = async () => {
    setIncomeLoading(true);

    try {
        const accountNames = formData.map((row) => row.accountName).filter((name) => name !== undefined);
        const amounts = formData.map((row) => row.amount).filter((amount) => amount !== undefined);
        const payload = {
            account_id: accountNames,
            gl_code: selectedDebitAccount,
            description: description,
            payment_mode: selectedPayment,
            breakdown_amount: amounts,
            total_amount: totalCredit,
            teller_no: teller,
            particulars: receive,
            currency: selectedCurrency,
            transaction_date: selectedDate,
            bank_id: selectedBanks
        };

        console.log("Payload:", payload);

        const response = await axios.post(`${BASE_URL}/post-receipt`, payload, { headers });

        console.log(response.data, "Response Data");
       handleClose1();
        Swal.fire({
          icon: 'success',
          title: 'Success',
          text: response.data.message,
        });

        // toast.success(response.data.message);
    } catch (error) {
        let errorMessage = 'An error occurred. Please try again.';
        if (error.response && error.response.data && error.response.data.message) {
          if (typeof error.response.data.message === 'string') {
              errorMessage = error.response.data.message;
          } else if (Array.isArray(error.response.data.message)) {
              errorMessage = error.response.data.message.join('; ');
          } else if (typeof error.response.data.message === 'object') {
              errorMessage = JSON.stringify(error.response.data.message);
              // toast.error(errorMessage);
            }
            console.log(error);
            Swal.fire({
              icon: 'error',
              title: 'Failed',
              text: JSON.stringify(error.response.data.message),
            });
        }
    } finally {
        setIncomeLoading(false);
    }
};
    


    const fetchPaymentMethod = async () => {
        setLoading(true);


        try {
            const response = await axios.get(`${BASE_URL}/income/get-payment-method`,
                {

                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${bearer}`
                    }
                }
            );
            const resultss = response.data?.data;
            setPaymentMethod(resultss);

              console.log(resultss, "PaymentModes");
        } catch (error) {
            const errorStatus = error.response.data.message;
            console.error(errorStatus);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (bearer) {
            fetchSubCat();
            fetchPaymentMethod();
            fetchDebit1();
            fetchDebit2();
        }
    }, [bearer]);

    const fetchCurrency = async () => {
        setCurrLoading(true);
        try {
          const response = await axios.get(`${BASE_URL}/fetch-all-currencies`, { headers });
          const results = response.data?.data;
            // console.log(results, "currencis")
          const options = results.map((item) => ({
            label: item.code,
            value: item.id,
            symbol: item.symbol
          }));
          setCurrency(results);
          setSelectOptions(options);
        } catch (error) {
          const errorStatus = error.response?.data?.message;
          console.log(errorStatus);
          setCurrency([]);
        } finally {
            setCurrLoading(false);
        }
      };

      useEffect(() => {
        if (bearer) {
            fetchCurrency();
            fetchSubBanks();
        }
    }, [bearer]);


    const handleCurrencyChange = (selectedOption) => {
        setSelectedCurrency(selectedOption.value);
      };

        const handleAccountChange = (selectedOption, index) => {
      const selectedAccount = selectedOption.value;
      const selectedItem = income.find(item => item.id === selectedAccount);
      // const intselectedId = parseInt(selectedAccount);
     const selectedCode = selectedItem?.gl_code
      // const selectedGlCode = subCat.find((item) => item.id === intselectedId) || '';

      const updatedFormData = [...formData];
      updatedFormData[index] = {
          ...updatedFormData[index],
          accountName: selectedAccount,
          accountCode: selectedCode,
      };

      setFormData(updatedFormData);
  };

    const handleValueChange = (value) => {
        setIncomeAmount(value);
    };

    const handleValueChange1 = (value, index) => {
        const updatedFormData = [...formData];
        updatedFormData[index] = {
            ...updatedFormData[index],
            amount: value,
        };
        setFormData(updatedFormData);
        calculateTotalCredit(); // Recalculate total credit whenever table amounts change
    };


    const calculateTotalCredit = () => {
        const total = formData.reduce((acc, item) => acc + parseFloat(item.amount || 0), 0);
        const formattedTotal = total.toFixed(2);
        setTotalCredit(formattedTotal);
    };


    useEffect(() => {

        calculateTotalCredit();
    }, [formData]);



    
    const oopt = income.map((item) => ({
      label: item.gl_name,
      value: item.id,
      
    }));


  const printRef = useRef();
  const pageMap = {
    "/dashboard": "Dashboard",
    "/transactions": "Transactions",
    "/accounts": "Accounting",
    "/reports": "Reports",
    "/banking": "Banking",
    "/settings": "Settings",
  };


    const handleRadioChange = (e) => {
    const value = e.target.value;
    setSelectedRadio(value);

    if (value === "general") {
      setSelectedCustomer(null);
    }
  };

    const handleDateChange = (e) => {
  const newDate = e.target.value;

  // Ensure minDate and maxDate are set
  if (!minDate || !maxDate) return;

  // Block if outside range
  if (newDate < minDate || newDate > maxDate) {
    alert(`Please select a date between ${minDate} and ${maxDate}`);
    return;
  }

  setSelectedDate(newDate);
};

 const handlePaymentChange = (event) => {
        setSelectedPayment(event.target.value);
    };
    // const handleCurrencyChange = (event) => {
    //     setSelectedCurrency(event.target.value);
    // };

    const handleAssetChange = (selectedOption) => {
        setSelectedDebitAccount(selectedOption.value);
    };
    const handleBanksChange = (selectedOption) => {
        setSelectedBanks(selectedOption.value);
    };


const fetchData = async () => {
  setBenLoading(true);
  try {
    const response = await axios.get(`${BASE_URL}/cash_movement`, { headers });
    const results = response.data?.data;
    // console.log(results, "movement");
    setTableData(results);
  } catch (error) {
    if (error.response && error.response.status === 401) {
      // Redirect to login page if unauthorized
      navigate('/login');
    } else {
      const errorStatus = error.response?.data?.message;
      console.log(errorStatus);
      setTableData([]);
    }
  } finally {
    setBenLoading(false);
  }
};

useEffect(() => {
  if (bearer) {
    fetchData();
  }
}, [bearer, currentPage]);

   const fetchReceipt2 = async () => {
        setIsLoading(true);
        try {
            const response = await axios.get(`${BASE_URL}/fetch-queried-receipts?page=${currentPage}`, { headers });
            const results = response.data?.data?.data;
            const resultx = response.data?.data?.total;
            console.log(results, "fetched details");
            setLedgTableData2(results);
            console.log(results, "Checkt it");
            const total = response.data?.data?.last_page || 1;
            setTotalPagesFlagged(total);
            console.log("fetched Receipts:", results);
            
        } catch (error) {
            if (error.response && error.response.status === 401) {
                navigate('/login');
            } else {
                let errorMessage = 'An error occurred. Please try again.';
                if (error.response && error.response.data && error.response.data.message) {
                    if (typeof error.response.data.message === 'string') {
                        errorMessage = error.response.data.message;
                    } else if (Array.isArray(error.response.data.message)) {
                        errorMessage = error.response.data.message.join('; ');
                    } else if (typeof error.response.data.message === 'object') {
                      
                        console.log(errorMessage);
                    }
                }
                setLedgTableData2([]);
            }
        } finally {
            setIsLoading(false);
        }
    };


  useEffect(() => {
  if (!bearer) return;

  if (selectedOption === "all") {
    fetchData(currentPage);
  } else if (selectedOption === "flagged") {
    fetchReceipt2(currentPageFlagged);
  }
}, [bearer, selectedOption, currentPage, currentPageFlagged]);

const handleOptionChange = (e) => {
  setSelectedOption(e.target.value);
  // Reset pages when switching
  setCurrentPage(1);
  setCurrentPageFlagged(1);
};


    useEffect(() => {
      const fetchCurrencies = async () => {
        try {
          const token = localStorage.getItem("authToken");
          const res = await axios.get(`${BASE_URL}/v1/fetch-all-currencies`, {
            headers: {
              Authorization: `Bearer ${token}`,
              Accept: "application/json",
            },
          });
          const options = Array.isArray(res.data.data)
            ? res.data.data.map((item) => ({
              value: item.id, // use only id
              label: item.name || item.code,
            }))
            : [];
          setCurrencyOptions(options);
        } catch (err) {
          setCurrencyOptions([]);
        }
      };
      fetchCurrencies();
    }, []);

    useEffect(() => {
      const fetchBank = async () => {
        try {
          const token = localStorage.getItem("authToken");
          const res = await axios.get(`${BASE_URL}/v1/get-cash-and-bank`, {
            headers: {
              Authorization: `Bearer ${token}`,
              Accept: "application/json",
            },
          });
          const options = Array.isArray(res.data.data)
            ? res.data.data.map((item) => ({
              value: item.id, // use only id
              label: item.gl_name,
            }))
            : [];
          setBankOptions(options);
        } catch (err) {
          setBankOptions([]);
        }
      };
      fetchBank();
    }, []);

    useEffect(() => {
      const fetchBank2 = async () => {
        try {
          const token = localStorage.getItem("authToken");
          const res = await axios.get(`${BASE_URL}/v1/get-cash-and-bank`, {
            headers: {
              Authorization: `Bearer ${token}`,
              Accept: "application/json",
            },
          });
          const options = Array.isArray(res.data.data)
            ? res.data.data.map((item) => ({
              value: item.id, // use only id
              label: item.gl_name,
            }))
            : [];
          setBankOptions2(options);
        } catch (err) {
          setBankOptions2([]);
        }
      };
      fetchBank2();
    }, []);

    useEffect(() => {
      const fetchPaymentMode = async () => {
        try {
          const token = localStorage.getItem("authToken");
          const res = await axios.get(`${BASE_URL}/v1/income/get-payment-method`, {
            headers: {
              Authorization: `Bearer ${token}`,
              Accept: "application/json",
            },
          });
          const options = Array.isArray(res.data.data)
            ? res.data.data.map((item) => ({
              value: item.id, // use only id
              label: item.name,
            }))
            : [];
          setPaymentMode(options);
        } catch (err) {
          setPaymentMode([]);
        }
      };
      fetchPaymentMode();
    }, []);


      useEffect(() => {
        const fetchCustomers = async () => {
          try {
            const token = localStorage.getItem("authToken");
            const res = await axios.get(`${BASE_URL}/v1/beneficiary`, {
              headers: {
                Authorization: `Bearer ${token}`,
                Accept: "application/json",
              },
            });
            // Assuming response data is an array of currencies or customers
            const options = Array.isArray(res.data.data)
              ? res.data.data.map((item) => ({
                value: item.id,
                label: item.name,
              }))
              : [];
            setCustomerOptions(options);
          } catch (err) {
            setCustomerOptions([]);
          }
        };
        fetchCustomers();
      }, []);

      useEffect(() => {
        const fetchInvoiceOptions = async () => {
          try {
            const token = localStorage.getItem("authToken");
            const res = await axios.get(`${BASE_URL}/v1/fetch-pending-purchases-invoice`, {
              headers: {
                Authorization: `Bearer ${token}`,
                Accept: "application/json",
              },
            });
            console.log(res);
            // Assuming response data is an array of currencies or customers
            const options = Array.isArray(res.data.data)
              ? res.data.data.map((item) => ({
                value: item.id,
                label: `${item.invoice_number} - ${item.supplier?.name}`,
                balance: item.balance,
              }))
              : [];
            setInvoiceOptions(options);
          } catch (err) {
            setInvoiceOptions([]);
          }
        };
        fetchInvoiceOptions();
      }, []);
  

  // Skeleton loader rows
  // const SkeletonRows = () => (
  //   <>
  //     {[...Array(5)].map((_, idx) => (
  //       <tr key={idx}>
  //         {Array(10).fill().map((_, i) => (
  //           <td key={i}>
  //             <div className={classes.skeletonLoader}></div>
  //           </td>
  //         ))}
  //       </tr>
  //     ))}
  //   </>
  // );

  // Helper for status
  const statusClass = (status) => {
    if (status === "Success") return classes.greenStatus;
    if (status === "Pending") return classes.yellowStatus;
    return classes.redStatus;
  };

    // useEffect(() => {
    //   const link = document.createElement("link");
    //   link.rel = "stylesheet";
    //   link.href = "https://cdn.jsdelivr.net/npm/bootstrap@5.3.3/dist/css/bootstrap.min.css";
    //   document.head.appendChild(link);
    //   return () => {
    //     document.head.removeChild(link);
    //   };
    // }, []);

  const addPayment = async () => {
    setAddPaymenntLoad(true);
    try {
      const token = localStorage.getItem("authToken");
      const response = await axios.post(
        `${BASE_URL}/v1/pay-purchase-invoice`, 

        {
          payment_type: selectedRadio,
          transaction_date: paymentDate,
          supplier_id: selectedCustomer?.value,
          supplier: customerName,
          description: description,
          payment_mode: selectedPaymentMode?.value,
          currency: selectedCurrency?.value,
          amount: amount,
          credit: selectedBank?.value,
          debit: selectedBank2?.value,
        },
        { headers: {
                Authorization: `Bearer ${token}`,
                Accept: "application/json",
              },
            });

          Swal.fire({
            imageUrl: verified,
            title: 'Success!',
            text: response.data.message,
            confirmButtonText: "Okay",
            imageWidth: 48, 
            imageHeight: 48, 
            customClass: {
            title: classes.myTitle,
            popup: classes.myText,
            confirmButton: classes.myButton,
            },
            allowOutsideClick: false,
            preConfirm: () => {
              Swal.close();
            }
          });

       
          handleClose1();
          setDescription("");
          setAmount("");
          setCustomerName("");
          setPaymentDate("");
          setSelectedRadio("");
          setSelectedBank(null);
          setSelectedBank2(null);
          setSelectedCurrency(null);
          setSelectedCustomer(null);
          setSelectedPaymentMode(null);
      
    } catch (error) {
      let errorMessage = "An error occurred. Please try again.";
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        if (typeof error.response.data.message === "string") {
          errorMessage = error.response.data.message;
        } else if (Array.isArray(error.response.data.message)) {
          errorMessage = error.response.data.message.join("; ");
        } else if (typeof error.response.data.message === "object") {
          errorMessage = JSON.stringify(error.response.data.message);
        }
        Swal.fire({
          imageUrl: crop,
          imageWidth: 48,
          imageHeight: 48,
          title: "Failed!",
          confirmButtonText: "Okay",
          text: JSON.stringify(error.response.data.message),
          customClass: {
            title: classes.myTitle,
            popup: classes.myText,
            confirmButton: classes.myDeclineButton,
          },
          allowOutsideClick: false, // Prevent closing by clicking outside
          preConfirm: () => {
            Swal.close(); // Explicitly close the modal
          },
        });
      }
    } finally {
      setAddPaymenntLoad(false);
    }
  };

  const addPayment2 = async () => {
    setAddPaymenntLoad2(true);
    try {
      const token = localStorage.getItem("authToken");
      const response = await axios.post(
        `${BASE_URL}/v1/pay-supplier-purchase-invoice`, 

        {
          // payment_type: selectedRadio,
          transaction_date: paymentDate,
          id: selectedInvoice?.value,
          description: description,
          payment_mode: selectedPaymentMode?.value,
          currency: selectedCurrency?.value,
          amount: amount,
          credit: selectedBank?.value,
          debit: selectedBank2?.value,
        },
        { headers: {
                Authorization: `Bearer ${token}`,
                Accept: "application/json",
              },
            });

          Swal.fire({
            imageUrl: verified,
            title: 'Success!',
            text: response.data.message,
            confirmButtonText: "Okay",
            imageWidth: 48, 
            imageHeight: 48, 
            customClass: {
            title: classes.myTitle,
            popup: classes.myText,
            confirmButton: classes.myButton,
            },
            allowOutsideClick: false,
            preConfirm: () => {
              Swal.close();
            }
          });

         
          handleClose2();
          setDescription("");
          setAmount("");
          setCustomerName("");
          setPaymentDate("");
          setSelectedRadio("");
          setSelectedBank(null);
          setSelectedBank2(null);
          setSelectedCurrency(null);
          setSelectedCustomer(null);
          setSelectedPaymentMode(null);
      
    } catch (error) {
      let errorMessage = "An error occurred. Please try again.";
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        if (typeof error.response.data.message === "string") {
          errorMessage = error.response.data.message;
        } else if (Array.isArray(error.response.data.message)) {
          errorMessage = error.response.data.message.join("; ");
        } else if (typeof error.response.data.message === "object") {
          errorMessage = JSON.stringify(error.response.data.message);
        }
        Swal.fire({
          imageUrl: crop,
          imageWidth: 48,
          imageHeight: 48,
          title: "Failed!",
          confirmButtonText: "Okay",
          text: JSON.stringify(error.response.data.message),
          customClass: {
            title: classes.myTitle,
            popup: classes.myText,
            confirmButton: classes.myDeclineButton,
          },
          allowOutsideClick: false, // Prevent closing by clicking outside
          preConfirm: () => {
            Swal.close(); // Explicitly close the modal
          },
        });
      }
    } finally {
      setAddPaymenntLoad2(false);
    }
  };
const handleViews = (id) => {

  const foundCash = tableData.find(item => item.id === id);
  const cashId = foundCash.id;
  const cashUUID = foundCash.uuid;
setCashID(cashId);
  setFoundCashUUID(cashUUID);
  const foundCashArray = foundCash ? [foundCash] : [];
  setFoundCashArrays(foundCashArray);

  const {transaction_date  } = foundCash;
  setSelectedDate12(transaction_date || '');


  setShow1(true);

};

  const handleDateChange2 = (event) => {
      setSelectedDate2(event.target.value);
    };

//  const handlePrint = (rowData) => {
//   navigate("/invoice-previeww", {
//     state: {
//       invoiceNumber: rowData.invoice_number,
//       invoiceDate: rowData.invoice_date,
//       dueDate: rowData.due_date,
//       customer: {
//         name: rowData.customer_name,
//         phone_number: rowData.customer_phone,
//         email: rowData.customer_email,
//       },
//       items: rowData.items,
//       total: rowData.total,
//     },
//   });
// };

const handlePrint = (id) => {
        const selectedLedger = tableData.find(item => item.id === id);
        navigate('/print_cash_receipts', { state: { selectedLedger } });
    };

const filteredData = tableData.filter(item => item.description.toLowerCase().includes(searchTerm.toLowerCase()));

const totalPages = Math.ceil(filteredData.length / entriesPerPage);

const handlePrevPage = () => {
  setCurrentPage(Math.max(currentPage - 1, 1));
};

const handleNextPage = () => {
  setCurrentPage(Math.min(currentPage + 1, totalPages));
};

const totalEntries = filteredData.length;
const startIndexx = (currentPage - 1) * entriesPerPage + 1;
const endIndexx = Math.min(startIndexx + entriesPerPage - 1, totalEntries);
const displayedData = filteredData.slice(startIndexx - 1, endIndexx);
const handleFormChange = (index, field, value) => {
  let formattedValue = value;

  // Format the amount field
  if (field === 'amount' && value !== '') {
    formattedValue = (Number(value.replace(/\D/g, '')) || '').toLocaleString();
  }

  const updatedFormData = [...formData];
  updatedFormData[index][field] = formattedValue;
  setFormData(updatedFormData);
};

  return (
    <div>
         <Modal size='xl' show={show1} onHide={handleClose1} animation={false}>
                      <Modal.Header closeButton>
                        <Modal.Title>Cash Movement</Modal.Title>
                      </Modal.Header>
                      <Modal.Body>
                        <Form >
                        <div  style={{marginTop: 10}}>
                        <Row className="justify-content-left">
              <Col md={6}>
                <Form>
                  <Form.Group controlId="transactionDate">
                    <Form.Label className="mb-2">Transaction Date</Form.Label>
                    <Form.Control
                      type="date"
                      placeholder="Enter transaction date"
                      className="mb-3"
                     
                                           value={selectedDate12}
                                           min={minDate}
                                           max={maxDate} 
                    />
                  </Form.Group>
                </Form>
              </Col>
            </Row>
                      
      </div>
      <div style={{ marginTop: 20 }} />
      <div className="table-responsive">
                                    <table className="table display table-bordered table-striped table-hover bg-white m-0 card-table">
                                        <thead className={classes.tableHeader} style={{ whiteSpace: "nowrap", textAlign: "center", alignItems: "center" }}>
                                        <tr>
                                          <th>#</th>
                                          {/* <th style={{ width: '15%', }}>Transaction Date</th> */}
                                          <th style={{ width: '26%', }}>From Account</th>
                                          <th style={{ width: '26%', }}>To Account</th>
                                          <th style={{ width: '30%', }}>Description</th>
                                          {/* <th style={{ width: '15%', }}>DR/CR</th> */}
                                          <th style={{ width: '18%', textAlign: "right" }}>Amount</th>
                                          {/* <th style={{ width: '15%', }}>Cheque/Teller Number</th> */}
      
                                          {/* <th >
                                          <OverlayTrigger
                                            placement="top"
                                            className={classes.btndf1}
                                            overlay={<Tooltip id="button-tooltip"  className={classes.btndf1}>Click here to add new row</Tooltip>}
                                          >
                                            <Button variant="primary" onClick={() => addRow()} style={{ borderRadius: "50px" }}>
                                            <i className="fas fa-plus"></i>
                                          </Button>
                                          </OverlayTrigger>
                                          </th> */}
      
                                        </tr>
                                      </thead>
                                      <tbody style={{ whiteSpace: "nowrap", textAlign: "center", alignItems: "center" }}>
                                        {foundCashArrays.map((row, index) => (
                                          <tr key={index}>
                                            <td>{row.sn}</td>
                                            {/* <td>
                                              <input
                                                value={row.date}
                                                onChange={(e) => handleFormChange(index, 'date', e.target.value)}
                                                className="form-control"
                                                type="date"
                                                min={minDate}
                                                max={maxDate}                        
                                              />
                                            </td> */}
                                            <td >
                                            {row?.from_account?.gl_name}
                                              {/* <Select
                                                value={selectedOptions[index]}
                                                onChange={(selectedOption) => handleAccountChange(selectedOption, index)}
                                                options={selectOptions}
                                                menuPortalTarget={document.body}
                                                styles={{
                                                  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                  menu: (provided) => ({
                                                    ...provided,
                                                    // maxHeight: '200px', 
                                                    // overflowY: 'auto',
                                                  }),
                                                }}
                                              /> */}
      
                                            </td>
                                            <td >
                                            {row?.to_account?.gl_name}
                                              {/* <Select
                                                value={selectedOptions1[index]}
                                                onChange={(selectedOption) => handleAccountChange1(selectedOption, index)}
                                                options={selectOptions}
                                                menuPortalTarget={document.body}
                                                styles={{
                                                  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                  menu: (provided) => ({
                                                    ...provided,
                                                    // maxHeight: '200px', 
                                                    // overflowY: 'auto',
                                                  }),
                                                }}
                                              /> */}
      
                                            </td>
                                            <td>
                                              <textarea
                                                type="text"
                                                className="form-control"
                                                rows={1}
                                                value={row.description}
                                                disabled
                                                onChange={(e) => handleFormChange(index, 'description', e.target.value)}
                                              />
                                            </td>
                                            {/* <td>
                                              <Form.Select
                                                value={row.DR_CR}
                                                onChange={(e) => handleFormChange(index, 'DR_CR', e.target.value)}
                                                className="form-control"
                                              >
                                                <option value="">Select</option>
                                                <option value="1">DR</option>
                                                <option value="2">CR</option>
                                              </Form.Select>
                                            </td> */}
                                            <td>
                                              <CurrencyInput
                                                name={`rowAmount ${index}`} // Provide a unique name for each CurrencyInput
                                                decimalsLimit={2}
                                                value={row.amount}
                                                disabled
                                                className="form-control"
                                                onValueChange={(value) => handleValueChange1(value, index)}
                                                style={{ textAlign: "right", border: "none" }}
                                              />
                                              {/* <input
                                                      type="text"
                                                      className="form-control"
                                                      value={row.amount}
                                                      onChange={(e) => handleFormChange(index, 'amount', e.target.value)}
                                                      style={{ textAlign: "right" }}
                                                    /> */}
                                            </td>
                                            {/* <td>
                                              <input
                                                value={row.cheque}
                                                onChange={(e) => handleFormChange(index, 'cheque', e.target.value)}
                                                className="form-control"
                                                type="text"
                                              />
                                            </td> */}
      
      
                                            {/* <td style={{ textAlign: "left" }}>
                                            <OverlayTrigger
                                              placement="top"
                                              className={classes.btndf1}
                                              overlay={<Tooltip id="button-tooltip"  className={classes.btndf1}>Click here to delete row</Tooltip>}
                                            >
                                              <Button variant="danger" onClick={() => deleteRow(index)} style={{ borderRadius: "50px" }}>
                                                <i className="far fa-trash-alt"></i>
                                              </Button>
                                            </OverlayTrigger>
                                            </td> */}
                                          </tr>
                                        ))}
                                      </tbody>
                                    </table>
      
                                  </div>
                        </Form>
                      </Modal.Body>
      
                      <Modal.Footer>
                        <Button variant="danger" onClick={handleClose1}>
                          Go back
                        </Button>
                        <Button
                                className={classes.longbtn}
                                  variant='success'
                                  onClick={createJournals}
                                  // disabled={!isEqual}
                                  style={{ padding: '5px 30px', backgroundColor: "#092147" }}>
                                  {load ? (
                                    <>
                                      <Spinner size='sm' />
                                      <span style={{ marginLeft: '5px' }}>Reversing, Please wait...</span>
                                    </>
                                  ) : (
                                    "Reverse"
                                  )}
                                </Button>
                      </Modal.Footer>
                    </Modal>
      <HeaderNav  />

      <div className={classes.Container}>
        {/* <div className={classes.actions}>

                    <button className={`${classes.btnss} ${classes.greens}`}>New Sales Invoice</button>
                    <button className={classes.btns}>New Purchase Invoice</button>
                    <button className={classes.btns}>All Invoices</button>
                    <button className={classes.btns}>Product & Services </button>

                </div> */}
        <div className={classes.actionsbtn}>
          <button className={classes.btns}>New Sales Invoice</button>
          <button className={classes.btns}>New Purchase Invoice</button>
          <button className={classes.btns}>All Invoices</button>
          <button className={`${classes.btns} ${classes.greens}`}>Product & Services</button>
        </div>

        <header className={classes.Header}>
          <h2 className={classes.Title}>Cash Movement</h2>
          <h1 className={classes.Titles}>
            View Cash Movement
          </h1>
        </header>

          <Row>
            <Col md={3}>
              <div className={classes.thrdkad}>
                <div className={classes.kad}>
                  <p className={classes.kdptg}>Total Receipts</p>
                  <p className={classes.kdptg1}>₦8,400,000.00</p>
                  <div className={classes.rvnue}>
                    <p className={classes.skaltxt}>This month</p>
                  </div>
                </div>
              </div>
            </Col>
            <Col md={3}>
              <div className={classes.frtkad}>
                <div className={classes.kad}>
                  <p className={classes.kdptg}>Cleared</p>
                  <p className={classes.kdptg2}>₦4,950,000.00</p>
                  <div className={classes.rvnue}>
                    <p className={classes.skaltxt}>Confirmed</p>
                  </div>
                </div>
              </div>
            </Col>
            <Col md={3}>
              <div className={classes.fiftkad}>
                <div className={classes.kad}>
                  <p className={classes.kdptg}>Pending</p>
                  <p className={classes.kdptg3}>₦3,200,000.00</p>
                  <div className={classes.rvnue}>
                    <p className={classes.skaltxt}>Awaiting Clearance</p>
                  </div>
                </div>
              </div>
            </Col>
            <Col md={3}>
              <div className={classes.frstkad}>
                <div className={classes.kad}>
                  <p className={classes.kdptg}>This Month</p>
                  <p className={classes.kdptg4}>12</p>
                  <div className={classes.rvnue}>
                    <p className={classes.skaltxt}>This month</p>
                  </div>
                </div>
              </div>
            </Col>
          </Row>

        <div className={classes.headerActions}>
          
          <div className={classes.actionsRight}>
          </div>
           <div className={classes.actionsLeft}>
            <button className={classes.btnss} onClick={handleShow2}> + Add Income</button>
           </div>
         
        </div>

        
                 <div className={classes.tableContainer}>
                 
               <table className={classes.tableTable}>
       <thead className={classes.tableHeader}>
                                  <tr style={{fontSize: "12px"}}>
                                  <th>S/N</th>
                               <th>UUID</th>
                               <th>Transaction Date</th>
                               <th>Description</th>
                               <th>From Account</th>
                               <th>To Account</th>
                               <th style={{textAlign: "right"}}>Total Amount</th>
                               <th>Actions</th>
                                 </tr>
       </thead>
       <tbody>
     
       { benLoading ? (
         searchTerm ? (
           <tr>
             <td colSpan={5} style={{ textAlign: "center" }}>
               Fetching Suppliers...
             </td>
           </tr>
         ) : (
           Array(8).fill().map((_, idx) => (
             <tr key={idx}>
               {Array(8).fill().map((_, i) => (
                 <td key={i}>
                   <Skeleton height={20} style={{ marginBottom: 10 }} />
                 </td>
               ))}
             </tr>
           ))
         )
       ) : (
         displayedData.map((item, index) => (
                               <tr key={index} style={{fontSize: "12px", fontWeight: "400", color: "#092147"}}>
                                 <td>{index + 1}</td>
                                 <td style={{ whiteSpace: 'wrap',  }}>{item.uuid}</td>
                                 <td style={{ textAlign: "left" }}>{item.transaction_date}</td>
                                 <td  style={{ whiteSpace: 'wrap', }}>{item.description}</td>
                                 <td style={{ whiteSpace: 'wrap',  }}>{item.from_account?.gl_name}</td>
                                 <td style={{ whiteSpace: 'wrap',  }}>{item.to_account?.gl_name}</td>
                                
                                 {/* <td style={{textAlign: "right"}}>{parseFloat(item?.total_debit).toLocaleString('en-US', {
                                               minimumIntegerDigits: 1,
                                               minimumFractionDigits: 2,
                                               maximumFractionDigits: 2
                                             })}</td> */}
                                 <td style={{textAlign: "right"}}>{parseFloat(item?.amount).toLocaleString('en-US', {
                                               minimumIntegerDigits: 1,
                                               minimumFractionDigits: 2,
                                               maximumFractionDigits: 2
                                             })}</td>
                                              {/* <td>{formatDate(item.created_at)}</td> */}
                                 <td >
                                   <div style={{display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center"}}>
                                       {/* <div
                                         onClick={() => handleTrashClick(item.uuid)}
                                         
                                         style={{ padding: '0 10px', cursor: "pointer", }}
                                       >
                                         <MdOutlineRestorePage fontSize={20} style={{color: "#2D995F", }} />
                                       </div> */}
                                       <div   
                                       onClick={() => handleViews(item.id)}  
                                       // className="mr-1 btn btn-success-soft btn-sm"
                                       >
                                       <img src={EyeIcon} />
                                                                                 </div>
                                       {/* <div   onClick={() => handleTrashClick12(item.uuid)}  className="mr-1 btn btn-danger-soft btn-sm">
                                                                                     <i className="far fa-trash-alt" style={{ color: "#dc3545", backgroundColor: "#dc35451a", padding: 2, borderColor: "#dc35454d", borderRadius: 5, fontSize: 12 }}></i>
                                                                                 </div> */}
                                       </div> 
     
                                 
                                 </td>
                               </tr>
         ))
       )
     }
       </tbody>
       {!benLoading && searchTerm && displayedData.length === 0 && (
       <tbody>
         <tr>
           <td colSpan={5} style={{ textAlign: "center" }}>
             No Suppliers found
           </td>
         </tr>
       </tbody>
     )}
     
     </table>
     
     {!benLoading && (
                 <div className={classes.paginationStyle}>
                   <div className={classes.footerSubOne}>
                     <button onClick={handlePrevPage}
                       disabled={currentPage === 1} className={classes.btnFirst}>Prev</button>
                     {[...Array(totalPages)].map((_, page) => {
                       // Show only 5 pages or less if available
                       if (page < 5 || page === currentPage - 1 || page === totalPages - 1) {
                         return (
                           <span key={page + 1} className={classes.ftOne}>
                             <button
                               className={`${classes.pageNumber} ${currentPage === page + 1 ? classes.active : ""}`}
                               onClick={() => setCurrentPage(page + 1)}
                             >
                               {page + 1}
                             </button>
                           </span>
                         );
                       }
                     })}
     
     
                     <button className={classes.btnSec} onClick={handleNextPage}
                       disabled={currentPage === totalPages}>Next</button>
                   </div>
                   <p className={classes.displayPag}>Displaying {`Page ${startIndexx}  - ${endIndexx} pages`} of {totalEntries} entries</p>
                 </div>
               )}
     
     
     
                 </div>
      </div>
       <CashMovementsModal
                      isOpen={show2}
                      onClose={() => setShow2(false)}
                      fetchData={fetchData}
                  />
     
{incomeLoading && (
        <div className={classes.overlay}>
          <img src={RotatingLogo} alt="Loading..." className={classes.spinnerLogo} />
        </div>
      )}
{uploadLoading && (
        <div className={classes.overlay}>
          <img src={RotatingLogo} alt="Loading..." className={classes.spinnerLogo} />
        </div>
      )}
      {/* <Footer /> */}
    </div>
  );
};

export default CashMovements;
